export class KollaVarshamHelper {
    constructor(public enYear: number,
        public enMonth: number,
        public enDate: number,
        public mlYear: number,
        public mlMonth:number

    ) {

    }


}



